import { render, staticRenderFns } from "./DeleteVolumeDiscountConfirmationDialog.vue?vue&type=template&id=7b4c42c0"
import script from "./DeleteVolumeDiscountConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteVolumeDiscountConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports